/**
 * DealColumnExportButton — Botão de exportação da coluna do Kanban de Negócios
 * -----------------------------------------------------------------------------
 * A partir da v2.0.0 este componente é apenas um invólucro fino do
 * `ExportMenuButton` genérico: a geração do arquivo, a seleção de colunas, as
 * formas de entrega (arquivo/e-mail) e a auditoria passaram para o módulo
 * reutilizável de exportação (`src/lib/export`).
 *
 * Correção principal: a exportação agora envia TODOS os filtros da tela
 * (etiquetas, origens, motivos de perda, datas), então o arquivo traz
 * exatamente os negócios visíveis na coluna.
 *
 * @version 2.0.0
 * RELEASE: 2026-09-07 v2.0.0 - Migrado para o módulo genérico de exportação.
 * RELEASE: v1.0.0 - Versão inicial (CSV/XLS direto da coluna).
 */

import { ExportMenuButton } from '@/components/export/ExportMenuButton';
import type { DealFilters } from '@/hooks/useCrmDeals';
import type { CrmDealsExportParams } from '@/lib/export/sources/crmDealsSource';

interface DealColumnExportButtonProps {
  pipelineId: string;
  phaseId: string;
  phaseName: string;
  filters?: DealFilters;
  sortField?: string;
  sortDirection?: string;
}

export function DealColumnExportButton({
  pipelineId,
  phaseId,
  phaseName,
  filters,
  sortField = 'created_at',
  sortDirection = 'desc',
}: DealColumnExportButtonProps) {
  const params: CrmDealsExportParams = {
    kind: 'kanban',
    pipelineId,
    phaseId,
    phaseName,
    filters,
    sortField,
    sortDirection,
  };

  return (
    <ExportMenuButton
      sourceId="crm_deals"
      params={params}
      fileNameHint={phaseName}
      variant="icon"
    />
  );
}
